/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OffsetGrowthCenterResponseDto } from '../../models/offset-growth-center-response-dto';

export interface GrowthCenterControllerSearch$Params {

/**
 * 페이지 크기
 */
  pageSize: number;

/**
 * 정렬 기준
 */
  orderBy?: string;

/**
 * 정렬 방향
 */
  align?: 'asc' | 'desc';

/**
 * 검색어
 */
  query?: string;

/**
 * 페이지 번호
 */
  pageNo: number;

/**
 * 위치
 */
  location?: string;

/**
 * 반경
 */
  distance?: number;

/**
 * 발달센터바우처 사용여부
 */
  useVoucher?: 'YES' | 'NO' | 'CENTER_ASK';

/**
 * 발달센터바우처 사용여부
 */
  useVouchers?: Array<'YES' | 'NO' | 'CENTER_ASK'>;

/**
 * 치료 영역
 */
  area?: Array<'LANGUAGE' | 'HEARING' | 'ART_MUSIC' | 'BEHAVIOR_PLAY_PSYCHOLOGY' | 'SENSORY_MOVEMENT' | 'ETC'>;
}

export function growthCenterControllerSearch(http: HttpClient, rootUrl: string, params: GrowthCenterControllerSearch$Params, context?: HttpContext): Observable<StrictHttpResponse<OffsetGrowthCenterResponseDto>> {
  const rb = new RequestBuilder(rootUrl, growthCenterControllerSearch.PATH, 'get');
  if (params) {
    rb.query('pageSize', params.pageSize, {});
    rb.query('orderBy', params.orderBy, {});
    rb.query('align', params.align, {});
    rb.query('query', params.query, {});
    rb.query('pageNo', params.pageNo, {});
    rb.query('location', params.location, {});
    rb.query('distance', params.distance, {});
    rb.query('useVoucher', params.useVoucher, {});
    rb.query('useVouchers', params.useVouchers, {});
    rb.query('area', params.area, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<OffsetGrowthCenterResponseDto>;
    })
  );
}

growthCenterControllerSearch.PATH = '/api/growth-center/search';
